// extracted by mini-css-extract-plugin
export default {"wrapper":"Oferta_wrapper__osEJT","container":"Oferta_container__ZJs+Q"};